import type { UseInterventionSchedulingIndicatorResult } from "./intervention-indicator-scheduling.type";
import type { InterventionSchedulingState } from "@/entities/intervention";

import { useMemo } from "react";

import { useReferentialSchedulingStates } from "@/entities/referential/referential-scheduling-states";

import {
  getIndicatorSubTypes,
  getIndicatorTooltipFallback,
} from "./intervention-indicator-scheduling.helper";

export const useInterventionSchedulingIndicator = (
  schedulingState?: InterventionSchedulingState
): UseInterventionSchedulingIndicatorResult => {
  const {
    isLoading,
    isSuccess,
    schedulingStates: referential = [],
  } = useReferentialSchedulingStates();

  const subTypes = useMemo(
    () => getIndicatorSubTypes(schedulingState, referential),
    [schedulingState, referential]
  );

  const tooltipFallback = useMemo(
    () => getIndicatorTooltipFallback(referential),
    [referential]
  );

  const primarySchedulingIssue = useMemo(() => {
    if (!subTypes?.length) return undefined;

    return subTypes[0];
  }, [subTypes]);

  const noIndicator = useMemo(
    () => !schedulingState || isLoading || !isSuccess || !subTypes?.length,
    [schedulingState, isLoading, isSuccess, subTypes]
  );

  return {
    isLoading,
    isSuccess,
    subTypes,
    primarySchedulingIssue,
    tooltipFallback,
    noIndicator,
  };
};
